import { trigger, state, style, transition, animate } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SUBSCRIPTION_TYPES, proFeatureSubscriptionTypes } from 'src/app/models/payment';
import { arraysHaveSameValues } from 'src/app/utilities/array.utils';
import { IconTypes } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { PaymentService } from 'src/app/services/payment.service';
import { UserService } from 'src/app/services/user.service';
import { roleValueIDs } from 'src/app/models/user';

const fadeIn = trigger('fadeIn', [
  state('void', style({ opacity: 0 })), // Initial state
  transition(':enter, :leave', [animate('0.325s', style({ opacity: 1 }))]),
]);
@Component({
  selector: 'app-upgrade-plan-blocker',
  templateUrl: './upgrade-plan-blocker.component.html',
  styleUrls: ['./upgrade-plan-blocker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeIn],
})
export class UpgradePlanBlockerComponent {
  @Input() arrow?: 'top' | 'bottom' | 'left' | 'right';
  @Input() set requiredSubscriptions(subscriptionTypes: SUBSCRIPTION_TYPES[]) {
    if (arraysHaveSameValues(subscriptionTypes, proFeatureSubscriptionTypes)) {
      this.ctaText = [this.translate.instant('Pro'), this.translate.instant('Enterprise')];
    } else if (arraysHaveSameValues(subscriptionTypes, [SUBSCRIPTION_TYPES.ENTERPRISE])) {
      this.ctaText = [this.translate.instant('Enterprise')];
    } else {
      this.ctaText = [this.translate.instant('Pro'), this.translate.instant('Enterprise')];
    }
  }

  ctaText: string[] = [];
  isTeacherOrAdmin = true;

  constructor(
    private translate: TranslateService,
    private paymentService: PaymentService,
    private userService: UserService,
  ) {
    const user = this.userService.user.getValue()?.user;
    const role = user?.info?.role;
    this.isTeacherOrAdmin = role === roleValueIDs.teacher || role === roleValueIDs.admin;
  }

  openStartTrialModal(): void {
    this.paymentService.openStartTrialModal('upgrade_plan_blocker');
  }

  protected readonly IconTypes = IconTypes;
}
